import React from "react";
import * as ReactDOMClient from "react-dom/client";
import { init as initFullStory } from "@fullstory/browser";
import "./index.css";
import "@servicetitan/anvil-fonts/dist/css/anvil-fonts.css";
import App from "./App";
import { initializeDatadogRum } from "./init-datadog-rum";

initializeDatadogRum();

initFullStory({
  orgId: "8HR7J",
  devMode: process.env.NODE_ENV === "development",
});

const rootElement: HTMLElement = document.getElementById("root")!;
const root = ReactDOMClient.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
